import React from 'react';
import {TableStyle} from "./rigStatusStyle";
import RigStatusTable from "./rigStatusTable";
import TableReport from "../../../common/table/table";
import MessageEmptyData from "../../../common/messageEmptyData";

/**
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const RigStatusBody = (prop) => {
    const {filters, tableData} = prop;

    if (!filters.isSubmitted) {
        return null;
    }

    if (tableData.length === 0) {
        return <MessageEmptyData/>;
    }

    return (
        <div className="container-fluid">
            <TableStyle>
                <TableReport
                    columns={RigStatusTable()}
                    data={tableData}
                    exportOptions={{pdf: false, xlsx: true, csv: true}}
                    getExportFileName={() => 'rig_status'}
                    withGlobalSearch={true}
                />
            </TableStyle>
        </div>
    );
}

export default RigStatusBody;
